export const loadFindbarScript = () => {
	// Skip during Valto prerender — the injected script would be serialized into the cached snapshot
	if (window.$prerender === true) return;
	if (__BW_ENV__.REACT_APP_FINDBAR_ENABLED === 'true') {
		const lang = localStorage.getItem('I18N_LANGUAGE') === 'en' ? 'en' : 'el';
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = lang === 'el' ? __BW_ENV__.REACT_APP_FINDBAR_URL_EL : __BW_ENV__.REACT_APP_FINDBAR_URL_EN;
		script.async = true;
		document.body.appendChild(script);
	}
};

const loadCustomScripts = () => {
	loadFindbarScript();
};

export default loadCustomScripts;
